module.exports = __webpack_public_path__ + "img/check_grey.e1f2c7eb.svg";